var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#1D800D",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11997 19.1667C8.0533 19.1667 7.97997 19.16 7.91997 19.1534L6.4733 18.9534C5.77997 18.86 5.1533 18.24 5.04664 17.5334L4.84664 16.0734C4.77997 15.6067 4.97997 15 5.3133 14.66L8.23997 11.7334C7.76664 9.84003 8.3133 7.84003 9.70664 6.46003C11.8666 4.3067 15.38 4.30003 17.5466 6.46003C18.5933 7.5067 19.1666 8.90003 19.1666 10.38C19.1666 11.86 18.5933 13.2534 17.5466 14.3C16.1466 15.6867 14.1533 16.2334 12.2733 15.7534L9.33997 18.68C9.05997 18.9734 8.55997 19.1667 8.11997 19.1667ZM13.62 5.84003C12.4533 5.84003 11.2933 6.28003 10.4066 7.1667C9.20664 8.36003 8.7733 10.1067 9.2733 11.7334C9.32664 11.9134 9.27997 12.1 9.14664 12.2334L6.0133 15.3667C5.89997 15.48 5.80664 15.7734 5.82664 15.9267L6.02664 17.3867C6.06664 17.64 6.33997 17.9267 6.5933 17.96L8.04664 18.16C8.20664 18.1867 8.49997 18.0934 8.6133 17.98L11.76 14.84C11.8933 14.7067 12.0866 14.6667 12.26 14.72C13.8666 15.2267 15.62 14.7934 16.82 13.5934C17.6733 12.74 18.1466 11.5934 18.1466 10.38C18.1466 9.16003 17.6733 8.02003 16.82 7.1667C15.9533 6.2867 14.7866 5.84003 13.62 5.84003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1266 17.6933C9.99997 17.6933 9.8733 17.6466 9.7733 17.5466L8.23997 16.0133C8.04664 15.82 8.04664 15.5 8.23997 15.3066C8.4333 15.1133 8.7533 15.1133 8.94664 15.3066L10.48 16.84C10.6733 17.0333 10.6733 17.3533 10.48 17.5466C10.38 17.6466 10.2533 17.6933 10.1266 17.6933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 11.8333C12.84 11.8333 12.1666 11.1599 12.1666 10.3333C12.1666 9.50659 12.84 8.83325 13.6666 8.83325C14.4933 8.83325 15.1666 9.50659 15.1666 10.3333C15.1666 11.1599 14.4933 11.8333 13.6666 11.8333ZM13.6666 9.83325C13.3933 9.83325 13.1666 10.0599 13.1666 10.3333C13.1666 10.6066 13.3933 10.8333 13.6666 10.8333C13.94 10.8333 14.1666 10.6066 14.1666 10.3333C14.1666 10.0599 13.94 9.83325 13.6666 9.83325Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.50541adbcfd21fe9aa9434d1eff8748a.svg";
export { ForwardRef as ReactComponent };